export const CustomerColors = {
  green: "#01827D",
  lightGreen: "#00ada7",
  darkerGreen: "#016662",
};
